import React from "react";
import { Route } from "react-router-dom";

import { FourOhThree } from "shared/pages";
import { useProfileContext } from "Auth/contexts";

export interface AdminRouteProps {
  component: React.ComponentType<any>;
}

/*
  This component redirects to the login page when the user is not authenticated.
  The path the user was trying to access is added to the state so the user can be redirected 
  back to that page when they login.
*/
export const AdminRoute: React.FC<AdminRouteProps> = ({ component: Component, ...rest }) => {
  const { isAdmin } = useProfileContext();

  return (
    <Route {...rest} render={props => (isAdmin ? <Component {...props} /> : <FourOhThree />)} />
  );
};
